import React from "react";
import {css, Theme} from "@emotion/react";

import {flexAlignCenter, mb, mt} from "@pg-design/helpers-css";

import {IRankingPosition} from "../../../types/IRankingPosition";
import {AwardedOffersBox} from "./AwardedOfferBox";
import {WinningOffersBox} from "./WinningOfferBox";

interface IProps {
    positions: IRankingPosition[];
}

const WINNERS_COUNT = 3;

export const WinningOffersList = ({positions}: IProps) => {
    return (
        <div css={winningOffersList}>
            {positions.map(({offer, position}, index) => {
                if (index < WINNERS_COUNT) {
                    return <WinningOffersBox offer={offer} position={position} key={offer.id} />;
                }

                return <AwardedOffersBox css={index === WINNERS_COUNT ? mt(2) : undefined} offer={offer} key={offer.id} />;
            })}
        </div>
    );
};

const winningOffersList = (theme: Theme) => css`
    ${mb(6)};
    ${flexAlignCenter};
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.sm}) {
        margin-bottom: 8.8rem;
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {flexAlignCenter, mb, mt} from "@pg-design/helpers-css";

import {IRankingPosition} from "../../../types/IRankingPosition";
import {AwardedOffersBox} from "./AwardedOfferBox";
import {WinningOffersBox} from "./WinningOfferBox";

interface IProps {
    positions: IRankingPosition[];
}

const WINNERS_COUNT = 3;

export const WinningOffersList = ({positions}: IProps) => {
    return (
        <div css={winningOffersList}>
            {positions.map(({offer, position}, index) => {
                if (index < WINNERS_COUNT) {
                    return <WinningOffersBox offer={offer} position={position} key={offer.id} />;
                }

                return <AwardedOffersBox css={index === WINNERS_COUNT ? mt(2) : undefined} offer={offer} key={offer.id} />;
            })}
        </div>
    );
};

const winningOffersList = (theme: Theme) => css`
    ${mb(6)};
    ${flexAlignCenter};
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.sm}) {
        margin-bottom: 8.8rem;
    }
`;
